import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, errMsg, imgUrl } from "@/lib/api";
import { PageHeader, Panel, DarkBtn, ConfirmDelete, ImageUpload, Field } from "@/components/admin/AdminUI";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [image, setImage] = useState("");
  const [title, setTitle] = useState("");

  const load = () => api.get("/gallery").then(({ data }) => setItems(data));
  useEffect(() => {
    load();
  }, []);

  const add = async () => {
    if (!image) return toast.error("Önce bir fotoğraf yükleyin");
    try {
      await api.post("/admin/gallery", { image, title, order: items.length });
      setImage("");
      setTitle("");
      toast.success("Galeriye eklendi");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const remove = async (id) => {
    await api.delete(`/admin/gallery/${id}`);
    load();
  };

  return (
    <div data-testid="admin-gallery-page">
      <PageHeader title="Galeri" desc="Ana sayfadaki 'Sofradan kareler' bölümü." />
      <Panel className="p-5 mb-6 grid sm:grid-cols-[auto_1fr_auto] gap-4 items-end">
        <ImageUpload value={image} onChange={setImage} testid="gallery-image" />
        <Field label="Başlık"><Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="örn. Pazar kahvaltısı" data-testid="gallery-title-input" /></Field>
        <DarkBtn onClick={add} data-testid="gallery-add-btn"><Plus size={16} /> Ekle</DarkBtn>
      </Panel>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((g) => (
          <div key={g.id} className="group relative rounded-lg overflow-hidden border border-[#E5DCD0] bg-white" data-testid={`admin-gallery-item-${g.id}`}>
            <img src={imgUrl(g.image)} alt={g.title} className="h-44 w-full object-cover" />
            <div className="p-3 flex items-center justify-between gap-2">
              <p className="text-sm truncate">{g.title || "—"}</p>
              <ConfirmDelete onConfirm={() => remove(g.id)}>
                <button className="p-1.5 rounded-md hover:bg-red-50 text-[#C84B31]" aria-label="Sil" data-testid={`admin-gallery-delete-${g.id}`}><Trash2 size={14} /></button>
              </ConfirmDelete>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
